import { useTranslation } from 'react-i18next';

const HERO_IMAGE = '/hero.png';

export function ScreenshotCarousel() {
  const { t } = useTranslation();

  return (
    <div className="screenshot-carousel" aria-label={t('home.heroAlt')}>
      <div className="screenshot-carousel__viewport">
        <div className="screenshot-carousel__track screenshot-carousel__track--single">
          <img
            src={HERO_IMAGE}
            alt={t('home.heroAlt')}
            className="screenshot-carousel__slide screenshot-carousel__slide--hero"
            loading="eager"
            decoding="async"
            draggable={false}
          />
        </div>
      </div>
    </div>
  );
}
